export const createDeleteImportationForm = id => `configDeleteImporationProductForm${id}`;